import './src/styles/global.css';
import React from 'react';
import { Location } from '@gatsbyjs/reach-router';
import Surveys  from './src';

export const wrapPageElement = ({ element }) => {
  return (
    <>
      {element}
      <Location>
        {({ location }) => (
          <Surveys path={location.pathname} />
        )}
      </Location>
    </>
  )
}